import { useRef, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Camera } from "lucide-react";
import { Section, PhotoUploader } from "./fields";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Owns the profile picture state + upload/remove API calls.
export function ProfilePhotoSection({ initialPicture, name }) {
  const [picture, setPicture] = useState(initialPicture || "");
  const [uploading, setUploading] = useState(false);
  const fileInputRef = useRef(null);

  const onFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (!/^image\/(jpe?g|png|webp)$/i.test(file.type)) {
      toast.error("Use JPG, PNG ou WEBP.");
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      toast.error("Imagem demasiado grande (máx 5 MB).");
      return;
    }
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const r = await axios.post(`${API}/members/me/photo`, fd, {
        withCredentials: true,
        headers: { "Content-Type": "multipart/form-data" },
      });
      setPicture(r.data.picture);
      toast.success("Fotografia atualizada.");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Erro ao carregar imagem.");
    } finally {
      setUploading(false);
      if (fileInputRef.current) fileInputRef.current.value = "";
    }
  };

  const onRemove = async () => {
    if (!window.confirm("Remover a sua fotografia de perfil?")) return;
    try {
      await axios.delete(`${API}/members/me/photo`, { withCredentials: true });
      setPicture("");
      toast.success("Fotografia removida.");
    } catch (err) {
      toast.error("Erro ao remover.");
    }
  };

  return (
    <Section icon={Camera} title="Foto de perfil">
      <PhotoUploader
        picture={picture}
        uploading={uploading}
        fileInputRef={fileInputRef}
        name={name}
        onPick={() => fileInputRef.current?.click()}
        onFileChange={onFileChange}
        onRemove={onRemove}
      />
    </Section>
  );
}
